<template>
  <div class="set-location">
    <div
      v-if="modelValue && modelValue.name"
      class="address-search address-search--current"
    >
      <div class="address">{{ modelValue.name }}</div>
      <div class="actions">
        <a class="button button--remove" @click="remove">Remove</a>
      </div>
    </div>
    <div class="location-prompt" v-show="!modelValue">
      <label for="address" class="visuallyhidden">{{
        $t("address.label")
      }}</label>
      <div class="address-search">
        <a
          class="button button--location"
          title="Use current location"
          @click="getCurrentLocation()"
          >Get location</a
        >
        <Autocomplete
          v-model="selectItem"
          :getResults="getResults"
          :format="getLabel"
          :setFocus="false"
        />
      </div>
    </div>
  </div>
</template>
<script>
import Autocomplete from "@/components/Autocomplete.vue";
import bingMaps from "@/bingMaps";

export default {
  components: {
    Autocomplete
  },
  compatConfig: { COMPONENT_V_MODEL: false },
  props: {
    route: {
      type: String,
      default: "location"
    },
    modelValue: {
      type: Object
    }
  },
  emits: ["update:modelValue"],
  data() {
    return {
      selectItem: null
    };
  },
  computed: {
    hideUnitSelection() {
      return this.$t("units.hide-selection") === "true";
    }
  },
  compatConfig: { COMPONENT_V_MODEL: false },
  methods: {
    getCurrentLocation() {
      navigator.geolocation.getCurrentPosition(location => {
        this.$emit("update:modelValue", {
          name: "Current location",
          point: {
            coordinates: [location.coords.latitude, location.coords.longitude]
          }
        });
      });
    },
    setLocation() {
      if (!this.modelValue) {
        return;
      }
      this.$emit("update:modelValue", this.modelValue);
    },
    getLabel(item) {
      if (!item) {
        return "";
      }
      if (item.name) {
        return item.name;
      }
      if (!!item.address && !!item.address.formattedAddress) {
        return item.address.formattedAddress;
      }
      return "";
    },
    getResults(query, populateResults) {
      if (query.length < 3) {
        populateResults([]);
      }
      bingMaps
        .getAutosuggestions({
          query,
          latitude: this.$store.state.location.latitude,
          longitude: this.$store.state.location.longitude
        })
        .then(results => {
          populateResults(results);
        });
    },
    remove() {
      this.$emit("update:modelValue", null);
    }
  },
  watch: {
    async selectItem() {
      let address = null;
      if (this.selectItem !== null) {
        address = await bingMaps.getLocationForAutosuggestion({
          item: this.selectItem,
          lang: this.$t.locale
        });
      }
      this.$emit("update:modelValue", {
        ...address,
        name: this.selectItem.name || this.selectItem.address.formattedAddress
      });
    }
  }
};
</script>